import ListProcesses from "@/views/agro_exporter/production/query_by_provider/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/production/query_by_provider/ShowProcess.vue";
import ShowProcessSummary from "@/components/views/agro_exporter/production/query_by_provider/show_process/Summary.vue";
import ShowProcessWeekly from "@/components/views/agro_exporter/production/query_by_provider/show_process/Weekly.vue";
import ShowProcessProviders from "@/components/views/agro_exporter/production/query_by_provider/show_process/Providers.vue";
import ShowProvider from "@/views/agro_exporter/production/query_by_provider/ShowProvider.vue";
import ShowProviderSummary from "@/components/views/agro_exporter/production/query_by_provider/show_provider/Summary.vue";
import ShowProviderWeekly from "@/components/views/agro_exporter/production/query_by_provider/show_provider/Weekly.vue";
import ShowProviderDetails from "@/components/views/agro_exporter/production/query_by_provider/show_provider/Details.vue";
import ShowExportedBatch from "@/views/agro_exporter/production/query_by_provider/ShowExportedBatch.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "production",
  permission: "query_by_provider"
});

export default [
  {
    path: "/ae/:agro_exporter_id/production/query_by_provider/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/production/query_by_provider/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/production/query_by_provider/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_summary") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "summary",
        name: routeName("show_process_summary"),
        component: ShowProcessSummary,
        props: true
      },
      {
        path: "weekly",
        name: routeName("show_process_weekly"),
        component: ShowProcessWeekly,
        props: true
      },
      {
        path: "providers",
        name: routeName("show_process_providers"),
        component: ShowProcessProviders,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/production/query_by_provider/show_provider/:agro_exporter_process_id/:provider_type/:provider_id",
    name: routeName("show_provider"),
    redirect: { name: routeName("show_provider_summary") },
    component: ShowProvider,
    props: true,
    meta: META,
    children: [
      {
        path: "summary",
        name: routeName("show_provider_summary"),
        component: ShowProviderSummary,
        props: true
      },
      {
        path: "weekly",
        name: routeName("show_provider_weekly"),
        component: ShowProviderWeekly,
        props: true
      },
      {
        path: "details",
        name: routeName("show_provider_details"),
        component: ShowProviderDetails,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/production/query_by_provider/exported_batch/:agro_exporter_process_id/:provider_type/:provider_id/:exported_batch_id",
    name: routeName("show_exported_batch"),
    component: ShowExportedBatch,
    props: true,
    meta: META
  }
];
